export default [
    {
        path: '/ccaa/convenios',
        name: 'conveniosCCAAList',
        component: () => import('../views/convenios/List.vue'),
        props: true,
    },
    {
        path: '/ccaa/convenios/create',
        name: 'conveniosCCAACreate',
        component: () => import('../views/convenios/Form.vue')
    },
    {
        path: '/ccaa/convenios/:id/edit',
        name: 'conveniosCCAAEdit',
        component: () => import('../views/convenios/Form.vue')
    },
    {
        path: '/ccaa/convenios/:id/show',
        name: 'conveniosCCAAView',
        component: () => import('../views/convenios/View.vue')
    },
]